var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.section === 'shop'),expression:"section === 'shop'"}],staticClass:"panel",attrs:{"id":"panel-shop"}},[_c('div',{staticClass:"container"},[_c('h3',[_vm._v("Upgrades")]),_vm._l((_vm.items),function(item,key){return _c('ShopItem',{attrs:{"shopItem":item}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }